export const PRESET_API_PREFIX_PATH = `${
  import.meta.env.VITE_APP_BASE_API_PRESET_PATH || '/customer-management'
}`;
export const PRESET_API_SUFFIX_PATH = `${
  import.meta.env.VITE_APP_BASE_API_PRESET_SUFFIX_PATH || '/um/presets'
}`;
export const PRESET_API_PREFIX = `${PRESET_API_PREFIX_PATH}${PRESET_API_SUFFIX_PATH}`;

export const SHAREABLE_PRESET_API_PREFIX = `${PRESET_API_PREFIX_PATH}/gm/presets`;
